module.exports = __webpack_public_path__ + "static/media/14B.d02027f4.png";